/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getReportTypeDecoder,
  getReportTypeEncoder,
  type ReportType,
  type ReportTypeArgs,
} from ".";

export type ComplianceReportGeneratedEvent = {
  report: Address;
  reportId: bigint;
  reportType: ReportType;
  complianceRate: bigint;
};

export type ComplianceReportGeneratedEventArgs = {
  report: Address;
  reportId: number | bigint;
  reportType: ReportTypeArgs;
  complianceRate: number | bigint;
};

export function getComplianceReportGeneratedEventEncoder(): FixedSizeEncoder<ComplianceReportGeneratedEventArgs> {
  return getStructEncoder([
    ["report", getAddressEncoder()],
    ["reportId", getU64Encoder()],
    ["reportType", getReportTypeEncoder()],
    ["complianceRate", getU64Encoder()],
  ]);
}

export function getComplianceReportGeneratedEventDecoder(): FixedSizeDecoder<ComplianceReportGeneratedEvent> {
  return getStructDecoder([
    ["report", getAddressDecoder()],
    ["reportId", getU64Decoder()],
    ["reportType", getReportTypeDecoder()],
    ["complianceRate", getU64Decoder()],
  ]);
}

export function getComplianceReportGeneratedEventCodec(): FixedSizeCodec<
  ComplianceReportGeneratedEventArgs,
  ComplianceReportGeneratedEvent
> {
  return combineCodec(
    getComplianceReportGeneratedEventEncoder(),
    getComplianceReportGeneratedEventDecoder(),
  );
}
